import { ACTION_REWARD_INFO, ACTION_REWARD_INFO_ERROR, ACTION_REWARD_INFO_SUCCESS } from "."
import * as api from "../../../api"
import * as authActions from "../../auth/actions";


export const getRewardInfoRequest = (access_token, url) => ({
    type: ACTION_REWARD_INFO,
    payload: {
        access_token,
        url
    }
})

export const getRewardInfoSuccess = data => ({
    type: ACTION_REWARD_INFO_SUCCESS,
    payload: {
        data
    }
})


export const getRewardInfoError = (msg) => ({
    type: ACTION_REWARD_INFO_ERROR,
    payload: {
        msg
    }
})

export const getRewardInfo = (access_token, url) => {
    return dispatch => {
        dispatch(getRewardInfoRequest(access_token, url))
        api.getRewardInfo(access_token, url)
            .then(({ data }) => {
                if (data.result.code !== 0) {
                    dispatch(getRewardInfoError("error"));
                    return
                }

                const {chip, percent, rates, progress, timestamp} = data
                dispatch(getRewardInfoSuccess({chip, percent, rates, progress, timestamp}));
            }).catch((err) => {

                console.log(err)

                if (err.response) {
                    if (err.response.status === 401) {
                        dispatch(authActions.logout())
                        return
                    }
                }

                dispatch(getRewardInfoError("system error"))
            });
    }
}